<template>
  <div class="text-center  brand-card-3">

    <div class="row align-items-center">
      <img :src="brand.image"
           :alt="brand.name" class="brand-card-3-image col ">

      <m-a class="brand-card-3-title col" :href="{name:'SingleBrand',params:{slug:brand.slug}}">
        <p class="text-center p-0 m-0">{{ brand.name }}</p>
      </m-a>
    </div>


  </div>
</template>

<script>
import mA from "../../Tags/A.vue";

export default {
  name: "BrandCard3",
  props: {
    brand: {}
  },
  components: {mA}
}
</script>

<style scoped>
.brand-card-3-image{
  object-fit: contain;
}
</style>